/**
=========================================================
* Argon Dashboard 2 MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

import Card from "@mui/material/Card";

// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

// Argon Dashboard 2 MUI examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import Grid from "@mui/material/Grid";

import { Dialog, DialogTitle, DialogContent, DialogActions,} from "@mui/material";

// Data
import ReferralTableData from "Views/Activities/Referral/data/ReferralTableData"
import { useState,useEffect } from "react";
import ApnaTabs from "components/ApnaTabs/ApnaTabs";
import ArgonInput from "components/ArgonInput";
import Dropdown from "components/CustomDropdown/Dropdown";
import ArgonButton from "components/ArgonButton";
import DeleteDialog from "components/DeleteDialog/DeleteDialog";
import FileUploader from "components/FileUploader/FileUploader";

function Tables() {
    //popup
        const[deleteDialog, setDeleteDialog] = useState(false);
         
        // Delete button click handler
        const handleDeleteClick = () => {
          setDeleteDialog(true);
        };

        // Close dialog
        const handleCloseDialog = () => {
          setDeleteDialog(false);
        };
  
        //popup
        const[deleteDialog1, setDeleteDialog1] = useState(false);
         
        // Delete button click handler
        const handleDeleteClick1 = () => {
          setDeleteDialog1(true);
        };

        // Close dialog
        const handleCloseDialog1 = () => {
          setDeleteDialog1(false);
        };
  
  const { columns, rows } = ReferralTableData(handleDeleteClick,handleDeleteClick1);

  const [fileName, setFileName] = useState(""); // file ka naam store karega

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name); // file name state me set karna
    }
  };

     const [status, setStatus] = useState("");

       const tabsData = [
      {label:"All",count:92,color:"#2027e1ff",content:""},
      {label:"Pending",count:12,color:"#ec3c10ff",content:""},
      {label:"Approved",count:22,color:"#ec10c7ff",content:""},
      {label:"Rejected",count:72,color:"#10a6ecff",content:""},
    ]
     
   const [aadhaarFiles, setAadhaarFiles] = useState([]);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card>
            <ArgonBox  p={3}>
              <ArgonTypography mb={2}  variant="h6" fontWeight="medium" >All Referral</ArgonTypography>

            <ArgonBox display="flex" alignItems="center" justifyContent="space-between" mb={2}>

            <ArgonBox sx={{height:"36px"}}>
              <ApnaTabs tabsData={tabsData} />
            </ArgonBox>

                <ArgonBox sx={{height:"36px"}} display="flex" alignItems="center" justifyContent="center">
             <ArgonInput placeholder="search" name="search" size="small" type="text" variant="outlined"/>
              </ArgonBox>
            </ArgonBox>
              
            </ArgonBox>

            <ArgonBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              <Table columns={columns} rows={rows} />
            </ArgonBox>
          </Card>
        </ArgonBox>

             {/* Dialog */}
         <Dialog
  open={deleteDialog}
  onClose={handleCloseDialog}
  maxWidth="sm"
  fullWidth
  sx={{
    "& .MuiDialog-paper": {
      borderRadius: "16px",
      boxShadow: "0 8px 30px rgba(0,0,0,0.1)",
      backgroundColor: "#fff",
    },
  }}
>
  {/* Header */}
  <DialogTitle
    sx={{
      pb: 2,
      borderBottom: "1px solid #f0f0f0",
      backgroundColor: "#fff",
    }}
  >
    <ArgonBox display="flex" alignItems="center" gap={2}>
      
      <ArgonBox>
        <ArgonTypography variant="h6" fontWeight="bold" color="text">
          Payment Processing
        </ArgonTypography>
        <ArgonTypography variant="caption" color="text.secondary">
          Approve or decline referral payment
        </ArgonTypography>
      </ArgonBox>
    </ArgonBox>
  </DialogTitle>

  {/* Body */}
  <DialogContent sx={{ p: 3, backgroundColor: "#fff" }}>
    <form>
      <Grid container spacing={3}>
        {/* Request Amount (disabled) */}
        <Grid item xs={12}>
          <ArgonTypography variant="body2" fontWeight="bold" mb={1}>
            Request Amount
          </ArgonTypography>
          <ArgonInput fullWidth disabled value="₹ 5,000" />
        </Grid>

        {/* Approved / Declined */}
        <Grid item xs={12}>
          <ArgonTypography variant="body2" fontWeight="bold" mb={1}>
            Approved/Declined
          </ArgonTypography>
          <Dropdown
            options={["Approved", "Declined"]}
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            width={520}
          />
        </Grid>
        {/* Payment Amount */}
        <Grid item xs={12}>
          <ArgonTypography variant="body2" fontWeight="bold" mb={1}>
            Payment Amount
          </ArgonTypography>
          <ArgonInput fullWidth placeholder="Enter actual payment amount" />
        </Grid>

         <Grid item xs={12}>
      <ArgonTypography variant="body2" fontWeight="bold" mb={1}>
        Payment Screenshot
      </ArgonTypography>
      <ArgonBox
        sx={{
          border: "2px dashed #d0d7de",
          borderRadius: "12px",
          p: 1,
          textAlign: "center",
          backgroundColor: "#fafafa",
          cursor: "pointer",
          transition: "0.3s",
          "&:hover": { backgroundColor: "#f5f5f5" },
        }}
      >
         
         <ArgonBox>
            <FileUploader
                  //   label="Aadhar"
                   files={aadhaarFiles}
                   setFiles={setAadhaarFiles}
                   accept="image/*,application/pdf"
                   multiple={false}
                   Width="100%"
                   Height={90}
                 />
         </ArgonBox>
                
        {/* <ArgonButton component="label" color="primary">
          Upload Screenshot
          <input
            type="file"
            hidden
            accept="image/*"
            onChange={handleFileChange}
          />
        </ArgonButton> */}
      </ArgonBox>

      {/* File name preview */}
      {/* {fileName && (
        <ArgonTypography
          variant="caption"
          color="text"
          sx={{ mt: 1, display: "block" }}
        >
         {fileName}
        </ArgonTypography>
      )} */}
    </Grid>

        {/* Transaction ID */}
        <Grid item xs={12}>
          <ArgonTypography variant="body2" fontWeight="bold" mb={1}>
            Transaction ID
          </ArgonTypography>
          <ArgonInput fullWidth placeholder="Enter transaction reference ID" />
        </Grid>
      </Grid>
    </form>
  </DialogContent>

  {/* Footer */}
  <DialogActions
    sx={{
      p: 3,
      gap: 2,
      borderTop: "1px solid #f0f0f0",
      backgroundColor: "#fff",
    }}
  >
    <ArgonButton variant="outlined" onClick={handleCloseDialog} color="primary">
      Cancel
    </ArgonButton>
    <ArgonButton variant="contained" color="primary">
      Process Payment
    </ArgonButton>
  </DialogActions>
</Dialog>


{/* Delete  */}
<DeleteDialog
  open={deleteDialog1}
  onClose={handleCloseDialog1}
  onConfirm={handleCloseDialog1}
  title="Delete Referral"
  description="Are you sure you want to delete this referral?"
  confirmText="Delete"
  cancelText="Cancel"
/>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
